<template>
    <div class="form-group">
        <label v-if="label">{{ label }}</label>
        <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }">
            <input v-model="hidden_value" @input="handleInput" @change="handleChange" :placeholder="placeholder || label" v-bind="$attrs" class="form-control" :class="errors[0] ? 'is-invalid' : ''" />
            <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
        </ValidationProvider>
    </div>
</template>

<script>
export default {
    props: ["label", "rules", "name", "value", "placeholder"],
    inheritAttrs: false,
    data() {
        return {
            hidden_value: this.value
        }
    },
    methods: {
        handleInput(e) {
            this.$emit('input', e.target.value)
        },
        handleChange(e) {
            this.$emit('change', e.target.value)
        }
    },
}
</script>